import React from "react";
import MListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';

const ListItemSecondaryAction = (props) => {
    return (
        <MListItemSecondaryAction {...props} />
    )
}

export default React.memo(ListItemSecondaryAction);